/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Resume_UpdatedInputs */

const en_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume updated`)
};

const de_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf aktualisiert`)
};

const fr_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV mis à jour`)
};

const es_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum actualizado`)
};

const it_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum aggiornato`)
};

const nl_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV bijgewerkt`)
};

const pl_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV zaktualizowane`)
};

const fi_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitetty`)
};

const da_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV opdateret`)
};

const sv_common_resume_updated = /** @type {(inputs: Common_Resume_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdaterat CV`)
};

/**
* | output |
* | --- |
* | "Resume updated" |
*
* @param {Common_Resume_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_resume_updated = /** @type {((inputs?: Common_Resume_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Resume_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_resume_updated(inputs)
	if (locale === "fr") return fr_common_resume_updated(inputs)
	if (locale === "es") return es_common_resume_updated(inputs)
	if (locale === "it") return it_common_resume_updated(inputs)
	if (locale === "nl") return nl_common_resume_updated(inputs)
	if (locale === "pl") return pl_common_resume_updated(inputs)
	if (locale === "fi") return fi_common_resume_updated(inputs)
	if (locale === "da") return da_common_resume_updated(inputs)
	if (locale === "sv") return sv_common_resume_updated(inputs)
	return en_common_resume_updated(inputs)
});